import React, { Fragment, useState } from 'react';
import Modal from '../../../common/Modal';
import Form from './form';
import { ToastContainer } from 'react-toastify';
import Dropdown from 'react-bootstrap/Dropdown';

const DprojectStatusForm = ({ isLink, orderPackageId }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <Fragment>
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <Modal
        modalIsOpen={isOpen}
        closeModal={closeModal}
        contentLabel="Ship"
        headerText="Update Status"
      >
       <Form orderPackageId={orderPackageId} isLink={isLink} closeModal={closeModal} />
      </Modal>

      {isLink && <Dropdown.Item onClick={openModal}>Deliveries</Dropdown.Item>}
      {!isLink && (
        <button
          onClick={openModal}
          type="button"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            backgroundColor: '#351c15',
            color: '#ffb500',
            height: '42px',
            padding: '0 20px',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: '500',
            border: '1px solid #4a2e19',
            cursor: 'pointer'
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M3 4a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm2 2V5h1v1H5zM3 13a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1v-3zm2 2v-1h1v1H5zM13 3a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1V4a1 1 0 00-1-1h-3zm1 2v1h1V5h-1z" clipRule="evenodd"/>
            <path d="M11 4a1 1 0 10-2 0v1a1 1 0 002 0V4zM10 7a1 1 0 011 1v1h2a1 1 0 110 2h-3a1 1 0 01-1-1V8a1 1 0 011-1zM16 9a1 1 0 100 2 1 1 0 000-2zM9 13a1 1 0 011-1h1a1 1 0 110 2v2a1 1 0 11-2 0v-3zM16 13a1 1 0 100 2h1a1 1 0 100-2h-1zM13 13a1 1 0 100 2h1a1 1 0 100-2h-1zM13 16a1 1 0 100 2h1a1 1 0 100-2h-1zM16 16a1 1 0 100 2h1a1 1 0 100-2h-1z"/>
          </svg>
          Deliveries
        </button>
      )}

    </Fragment>
  )
}

export default DprojectStatusForm;